import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/tailwind.css';

const VueTouch = require('vue2-touch-events');
Vue.config.productionTip = false

Vue.use(VueTouch);

new Vue({
  render: h => h(App),
}).$mount('#app')
